module.exports = __webpack_public_path__ + "static/img/03.eb03a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/280319/03.png
// module id = Lims
// module chunks = 0